import { createContext, useReducer } from 'react';
import {Route, Routes} from 'react-router-dom';
import './App.css';
import Protected from './Protected'
import Home from './Home';
import Login from './Login';
import Navbar from './Navbar';
import User from './User'
import Specility from './Speciality';
import Department from './Department';
import Diagnosis from './Diagnosis';
import Doctors from './Doctors';
import ResetPW from './ResetPW';
import Scheduler from './Scheduler';
import Visitors from './Visitors';
import Appointments from './Appointments';
import Testimonials from './Testimonials';
import DeptTestimonials from './DeptTestimonials';
import FAQ from './FAQ';
import DeptFAQ from './DeptFAQ';
import Disease from './Disease';
import Seotags from './Seotags';
import Treatments from './Treatments';
import Facilities from './Facilities';
import DiagService from './DiagService';
import HealthCard from './HealthCard'
import WhyChooseUs from './WhyChooseUs'
import DiagTestimonials from './DiagTestimonials'
import DiagFAQ from './DiagFAQ'
import HealthcardUser from './HealthcardUser'

import Dummy from './Dummy';

import { initialState, reducer } from '../src/reducer/UseReducer';

export const UserContext = createContext();

const Routing = ()=> {
  return(
    <Routes>

      <Route path="/" element={<Protected Cmp={Home} />} />
      <Route path="/Login" element={<Protected Cmp={Login} />} />
      <Route path="/bkoff/Logout" element={<Protected Cmp={Home} />} />
      <Route path="/bkoff/User" element={<Protected Cmp={User} />} />
      <Route path="/bkoff/Speciality" element={<Protected Cmp={Specility} />} />
      <Route path="/bkoff/Department" element={<Protected Cmp={Department} />} />
      <Route path="/bkoff/Doctors" element={<Protected Cmp={Doctors} />} />
      <Route path="/bkoff/Diagnosis" element={<Protected Cmp={Diagnosis} />} />
      <Route path="/bkoff/Scheduler" element={<Protected Cmp={Scheduler} />} />
      <Route path="/bkoff/Visitors" element={<Protected Cmp={Visitors} />} />
      <Route path="/bkoff/Appointments" element={<Protected Cmp={Appointments} />} />
      <Route path="/bkoff/Testimonials" element={<Protected Cmp={Testimonials} />} />
      <Route path="/bkoff/FAQ" element={<Protected Cmp={FAQ} />} />
      <Route path="/bkoff/Disease" element={<Protected Cmp={Disease} />} />
      <Route path="/bkoff/Seotags" element={<Protected Cmp={Seotags} />} />
      <Route path="/bkoff/ResetPW" element={<Protected Cmp={ResetPW} />} />
      <Route path="/bkoff/Treatments" element={<Protected Cmp={Treatments} />} />
      <Route path="/bkoff/Facilities" element={<Protected Cmp={Facilities} />} />
      <Route path="/bkoff/DeptTestimonials" element={<Protected Cmp={DeptTestimonials} />} />
      <Route path="/bkoff/DeptFAQ" element={<Protected Cmp={DeptFAQ} />} />
      <Route path="/bkoff/DiagService" element={<Protected Cmp={DiagService} />} />
      <Route path="/bkoff/HealthCard" element={<Protected Cmp={HealthCard} />} />
      <Route path="/bkoff/WhyChooseUs" element={<Protected Cmp={WhyChooseUs} />} />
      <Route path="/bkoff/DiagTestimonials" element={<Protected Cmp={DiagTestimonials} />} />
      <Route path="/bkoff/DiagFAQ" element={<Protected Cmp={DiagFAQ} />} />
      <Route path="/bkoff/HealthcardUser" element={<Protected Cmp={HealthcardUser} />} />
           
      <Route path="/bkoff/Dummy" element={<Protected Cmp={Dummy} />} />
    </Routes>
  )
}



function App() {

  const [state, dispatch] = useReducer(reducer, initialState);

  return (<>
    <UserContext.Provider value={{state,dispatch}}>
    <div className='App bg-[#e7e7e7d1 w-full h-screen' >
    <Navbar />
    <Routing />
    </div>
    </UserContext.Provider>
    </>
  );
}

export default App;
